export enum CampaignStatus {
  PENDING = "Pending",
  ACTIVE = "Active",
  CANCELLED = "Cancelled",
  COMPLETED = "Completed",
  AWAITING_PAYMENT = "Awaiting Payment"
}

export enum CampaignMode {
  EARN = "Earn",
  DISCOVER = "Discover"
}
